import { render, staticRenderFns } from "./FilterClientNotification.vue?vue&type=template&id=3121c602&scoped=true"
import script from "./FilterClientNotification.vue?vue&type=script&lang=ts"
export * from "./FilterClientNotification.vue?vue&type=script&lang=ts"
import style0 from "./FilterClientNotification.vue?vue&type=style&index=0&id=3121c602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3121c602",
  null
  
)

export default component.exports